import axios from '@/utils/axiosHelper';

// 初始化数据(含授权)
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/snail/clock/index', method: 'GET', params }, { interceptResultCode: false });
};

// 获取uuid-api
export const getUuidApi = (params) => {
  return axios({ url: '/snail/clock/uuid', method: 'POST', params }, { interceptResultCode: false });
};

// 支付api
export const paymentApi = (params) => {
  return axios({ url: '/snail/clock/pay', method: 'POST', params }, { interceptResultCode: false });
};

// 支付订单查询
export const wxPaymentApi = (params) => {
  return axios({ url: '/snail/clock/pay/show', method: 'POST', params }, { interceptResultCode: false });
};

// 退款api
export const getRefundApi = (params) => {
  return axios({ url: '/snail/clock/refund', method: 'GET', params }, { interceptResultCode: false });
};

// codeId查询api
export const wechatInfoAPI = (params) => {
  return axios({ url: '/wechat/info', method: 'GET', params }, { interceptResultCode: false });
};

// 查询签到
export const getClockSignAPI = (params) => {
  return axios({ url: '/snail/clock/sign', method: 'GET', params }, { interceptResultCode: false });
};


// WEBPACK FOOTER //
// ./src/pages/snail/dkhd/api.js